import React from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaYoutube, FaTwitter } from 'react-icons/fa';
import './Contact.css';
import { FaLinkedin } from 'react-icons/fa';

const Contact = () => {
  const contactInfo = [
    {
      type: 'Email',
      value: 'shristi2860@gmail.com',
      icon: <FaEnvelope />,
      link: 'mailto:shristi2860@gmail.com'
    },

        {
  type: 'LinkedIn',
  value: 'Shristi',
  icon: <FaLinkedin />,
  link: 'https://www.linkedin.com/in/shristi-90184b281/'
},
    {
      type: 'YouTube',
      value: '@shristiii76',
      icon: <FaYoutube />,
      link: 'https://www.youtube.com/@shristiii76'
    },
    {
      type: 'X (Twitter)',
      value: '@Night_kernel55',
      icon: <FaTwitter />,
      link: 'https://x.com/Night_kernel55'
    },

  ];

  return (
    <section id="contact" className="contact">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Get In Touch</h2>
          <div className="underline"></div>
        </motion.div>

        <motion.div
          className="contact-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <p className="contact-intro">
            I'm always open to discussing new opportunities, interesting projects, or just having a chat about technology.
            Feel free to reach out!
          </p>

          <div className="contact-grid">
            {contactInfo.map((contact, index) => (
              <motion.a
                key={contact.type}
                href={contact.link}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-card"
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05, y: -5 }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="contact-icon">
                  {contact.icon}
                </div>
                <div className="contact-details">
                  <h3>{contact.type}</h3>
                  <p>{contact.value}</p>
                </div>
              </motion.a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;